import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { reportService } from "../../../apis/apiServices/Report";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Template } from "devextreme-react";
import { AssetSubStatus, DefaultDateFormat } from "../../../helper/fixcode";
import { useSelector } from "react-redux";
import { assetService } from "../../../apis/apiServices/Asset";
import Modal from "react-modal";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
  Polyline,
} from "@react-google-maps/api";
import { Loader } from "../../Shared/PageLoader";

export default function ReportAssetDispatchComponent(props) {
  const user = useSelector((state) => state.user.data);
  const [state, setState] = useState({
    fromCoords: 0,
    toCoords: 0,
    selectedTabIndex: 0,
    isCompleteLoading: false,
    loadingMessage: "Loading Report...",
  });
  const [assetDispatchList, setAssetDispatchList] = useState([]);
  const [dispatchTripDetails, setDispatchTripDetails] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [rowData, setRowData] = useState(null);
  const refDataGrid = useRef(null);
  const [arrowPoints, setArrowPoints] = useState([]);
  const [activeMarker, setActiveMarker] = useState(null);
  const [activeMarkerInfo, setActiveMarkerInfo] = useState(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Dispatch`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getAssetDispatchList(0, user?.userId);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetDispatchList = async (assetDispatchId, userId) => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await reportService.getAssetDispatchList(
        assetDispatchId,
        userId
      );
      setAssetDispatchList(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const getDispatchTripDetails = async (dispatchId) => {
    try {
      const response = await assetService.getDispatchTripDetails(dispatchId);
      setDispatchTripDetails(response.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getLocationName = async (lat, lng) => {
    const geocoder = new window.google.maps.Geocoder();
    return new Promise((resolve) => {
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          resolve(results[0].formatted_address);
        } else {
          resolve("Unknown Location");
        }
      });
    });
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  keyExpr="id"
                  dataSource={assetDispatchList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarRefreshTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="id"
                    width={80}
                    caption=""
                    allowExporting={false}
                    allowFiltering={false}
                    allowSearch={false}
                    allowSorting={false}
                    cellRender={(cellData) => {
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            <span>
                              <button
                                style={{ cursor: "pointer" }}
                                type="button"
                                title="Track"
                                className="btn btn-primary btn-sm-1"
                                onClick={() => {
                                  setIsOpen(true);
                                  setRowData(cellData?.data);
                                  setState((prev) => ({
                                    ...prev,
                                    fromCoords: cellData?.data?.fromGeoLocation
                                      ? cellData?.data?.fromGeoLocation
                                          ?.split(",")
                                          .map(Number)
                                      : 0,
                                    toCoords: cellData?.data?.toGeoLocation
                                      ? cellData?.data?.toGeoLocation
                                          ?.split(",")
                                          .map(Number)
                                      : 0,
                                  }));
                                }}
                              >
                                <i
                                  className="fas fa-map-marked-alt"
                                  style={{
                                    width: "14px",
                                    height: "12px",
                                    marginTop: "5px",
                                  }}
                                ></i>
                                &nbsp;&nbsp;Replay
                              </button>
                            </span>
                          </div>
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="dispatchIndentNo"
                    caption="Asset Dispatch No"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="movementIndentNo"
                    caption="Asset Movement No"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="assetRequestSubNo"
                    caption="Asset Request No"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="dispatchDate"
                    caption="Dispatch Date"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    dataType="date"
                    format={DefaultDateFormat.GridDayMonthYearDateFormat}
                  />
                  <Column
                    dataField="allocatedAssetName"
                    caption="Asset Description"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    calculateCellValue={(data) => {
                      return `${data?.allocatedAssetName || ""} ${
                        data?.allocatedAssetSerialNo || ""
                      } ${data?.materialOrderDesc || ""}`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          {data?.data?.materialOrderDesc ? (
                            <>
                              <span>{data?.data?.materialOrderDesc ?? ""}</span>
                            </>
                          ) : (
                            <>
                              <span>
                                {data?.data?.allocatedAssetName ?? ""}
                              </span>
                              {data?.data?.allocatedAssetSerialNo && (
                                <>
                                  <br />
                                  <div
                                    style={{
                                      color: "#b1b1b1",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {data?.data?.allocatedAssetSerialNo ?? ""}
                                  </div>
                                </>
                              )}
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="categoryName"
                    caption="Category"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    calculateCellValue={(data) => {
                      return `${data?.categoryName || ""} ${
                        data?.subCategoryName || ""
                      } ${data?.orderSubCategory || ""} ${
                        data?.orderCategory || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          {data?.data?.orderSubCategory &&
                          data?.data?.orderCategory ? (
                            <>
                              <span>{data?.data?.orderCategory ?? ""}</span>
                              {data?.data?.orderSubCategory && (
                                <>
                                  <br />
                                  <div
                                    style={{
                                      color: "#b1b1b1",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {data?.data?.orderSubCategory ?? ""}
                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <span>{data?.data?.categoryName ?? ""}</span>
                              {data?.data?.subCategoryName && (
                                <>
                                  <br />
                                  <div
                                    style={{
                                      color: "#b1b1b1",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {data?.data?.subCategoryName ?? ""}
                                  </div>
                                </>
                              )}
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromUserFullName"
                    caption="From"
                    visible={false}
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromUserFullName || ""} ${
                        data?.fromUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromUserFullName ?? ""}</span>
                          {data?.data?.fromDepartment && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.fromDepartment ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="toUserFullName"
                    caption="To"
                    visible={false}
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    calculateCellValue={(data) => {
                      return `${data?.toUserFullName || ""} ${
                        data?.toDepartment || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.toUserFullName ?? ""}</span>
                          {data?.data?.toDepartment && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toDepartment ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromProjectName"
                    caption="Project"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromProjectName || ""} ${
                        data?.toProjectName || ""
                      } ${data?.materialOrderLocation || ""}`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          {data?.data?.materialOrderLocation ? (
                            <>
                              <span>
                                {data?.data?.materialOrderLocation ?? ""}
                              </span>
                            </>
                          ) : (
                            <>
                              <span>{data?.data?.fromProjectName ?? ""}</span>
                              {data?.data?.toProjectName && (
                                <>
                                  <br />
                                  <div
                                    style={{
                                      color: "#b1b1b1",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {data?.data?.toProjectName ?? ""}
                                  </div>
                                </>
                              )}
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="transportationName"
                    caption="Transportation Type"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="transportVehicle"
                    caption="Vehicle No."
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="transportVendorName"
                    caption="Vendor Name"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    visible={false}
                  />
                  <Column
                    dataField="statusName"
                    caption="Status"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    cellRender={(e) => {
                      let color = "#28A745";
                      if (
                        e.data?.statusId ===
                        Number(AssetSubStatus.AssetDispatchPending)
                      ) {
                        color = "#afad1eff";
                      } else if (
                        e.data?.statusId ===
                        Number(AssetSubStatus.AssetDispatchJobStarted)
                      ) {
                        color = "#16b36aff";
                      } else if (
                        e.data?.statusId ===
                        Number(AssetSubStatus.AssetDispatchJobStarted)
                      ) {
                        color = "#c50a23ff";
                      }

                      return (
                        <div>
                          <span style={{ color }}>{e.data?.statusName}</span>
                        </div>
                      );
                    }}
                  />
                  <Column
                    dataField="createdDate"
                    caption="Created On"
                    allowSearch={true}
                    allowFiltering={false}
                    calculateCellValue={(data) => {
                      return `${data?.createdDate || ""} ${
                        data?.createdByUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      if (data?.data?.createdDate) {
                        return (
                          <>
                            <span>
                              {moment(data?.data?.createdDate).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                moment(data?.data?.createdDate).format("LT") ??
                                ""}
                            </span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.createdByUserFullName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="updatedDate"
                    caption="Last updated"
                    allowSearch={true}
                    allowFiltering={false}
                    calculateCellValue={(data) => {
                      return `${data?.updatedDate || ""} ${
                        data?.updatedByUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      if (data?.data?.updatedDate) {
                        return (
                          <>
                            <span>
                              {moment(data?.data?.updatedDate).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                moment(data?.data?.updatedDate).format("LT") ??
                                ""}
                            </span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.updatedByUserFullName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            style={{ cursor: "pointer" }}
                            type="button"
                            title="Refresh"
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              try {
                                setState((prevState) => ({
                                  ...prevState,
                                  isCompleteLoading: true,
                                }));
                                await getAssetDispatchList(0, user?.userId);
                              } catch (error) {
                                console.log(error);
                              } finally {
                                setState((prevState) => ({
                                  ...prevState,
                                  isCompleteLoading: false,
                                }));
                              }
                            }}
                          >
                            <i className="fas fa-sync-alt"></i>
                            &nbsp;&nbsp;Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={10} />
                  <Pager
                    allowedPageSizes={[10, 15, 20, 50, 100]}
                    // displayMode="compact"
                    showPageSizeSelector={true}
                    showInfo={true}
                    visible={true}
                    showNavigationButtons={true}
                  />
                  <Export enabled={true} fileName="Asset Dispatch Report" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        onAfterOpen={async () => {
          await getDispatchTripDetails(rowData?.id);
        }}
        className={"react-modal custom-modal-xlarge"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Tracking Vehicle For Asset Dispatch"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`Tracking vehicle - [${rowData?.transportVehicle}] - for asset dispatch - [${rowData?.dispatchIndentNo}]`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              setIsOpen(false);
              setRowData(null);
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <TabPanel
            loop={true}
            width={"100%"}
            height={"80%"}
            animationEnabled={true}
            swipeEnabled={false}
            tabsPosition={"top"}
            stylingMode={"secondary"}
            iconPosition={"top"}
            //itemComponent={TabPanelItem}
            selectedIndex={state.selectedTabIndex}
            onSelectedIndexChange={(index) => {
              try {
                setState((prev) => ({ ...prev, selectedTabIndex: index }));
              } catch (error) {
                console.log(error);
              }
            }}
          >
            <Item title="View Dispatch Details" icon="map">
              <>
                <div className="row content-header">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="row">
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Asset Name</label>
                          <p className="labelvalue">
                            {rowData?.allocatedAssetName ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Vehicle No</label>
                          <p className="labelvalue">
                            {rowData?.transportVehicle ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Km Travelled</label>
                          <p className="labelvalue">{rowData?.lastKms ?? 0}</p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Start Time</label>
                          <p className="labelvalue">
                            {rowData?.startDate
                              ? moment(rowData?.startDate)
                                  .format(
                                    DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                                  )
                                  ?.toString()
                              : "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">End Time</label>
                          <p className="labelvalue">
                            {rowData?.endDate
                              ? moment(rowData?.endDate)
                                  .format(
                                    DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                                  )
                                  ?.toString()
                              : "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Status</label>
                          <p className="labelvalue">
                            {rowData?.statusName ?? "NA"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Total Kms</label>
                          <p className="labelvalue">{rowData?.totalKms ?? 0}</p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">ETA</label>
                          <p className="labelvalue">
                            {rowData?.etaDate
                              ? moment(rowData?.etaDate)
                                  .format(
                                    DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                                  )
                                  ?.toString()
                              : "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-8">
                        <div className="form-group mb-2">
                          <label className="mb-0">Current Location</label>
                          <p className="labelvalue">
                            {rowData?.currentDispatchLocation ?? "NA"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-6">
                        <div className="form-group mb-2">
                          <label className="mb-0">From Location</label>
                          <p className="labelvalue">
                            {rowData?.fromDispatchLocation ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="form-group mb-2">
                          <label className="mb-0">To Location</label>
                          <p className="labelvalue">
                            {rowData?.toDispatchLocation ?? "NA"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-12">
                        <div className="form-group mb-2">
                          {state.fromCoords && state.toCoords ? (
                            <>
                              {/* {isLoaded ? (
                                          <> */}
                              <LoadScript
                                googleMapsApiKey={
                                  process.env.REACT_APP_GOOGLE_MAP_API_KEY
                                }
                                libraries={["geometry"]}
                              >
                                <GoogleMap
                                  mapContainerStyle={{
                                    width: "100%",
                                    height: "400px",
                                  }}
                                  onLoad={(map) => {
                                    const bounds =
                                      new window.google.maps.LatLngBounds();
                                    bounds.extend({
                                      lat: state.fromCoords
                                        ? state.fromCoords[0]
                                        : 0,
                                      lng: state.fromCoords
                                        ? state.fromCoords[1]
                                        : 0,
                                    });
                                    bounds.extend({
                                      lat: state.toCoords
                                        ? state.toCoords[0]
                                        : 0,
                                      lng: state.toCoords
                                        ? state.toCoords[1]
                                        : 0,
                                    });
                                    map.fitBounds(bounds);
                                    const path = [
                                      {
                                        lat: state.fromCoords[0],
                                        lng: state.fromCoords[1],
                                      },
                                      {
                                        lat: state.toCoords[0],
                                        lng: state.toCoords[1],
                                      },
                                    ];
                                    const totalDistance =
                                      window?.google?.maps?.geometry?.spherical?.computeLength(
                                        path
                                      );
                                    const points = [];
                                    for (
                                      let d = 0;
                                      d <= totalDistance;
                                      d += 500
                                    ) {
                                      const point =
                                        window?.google?.maps?.geometry?.spherical?.interpolate(
                                          path[0],
                                          path[1],
                                          d / totalDistance
                                        );
                                      points.push(point);
                                    }
                                    setArrowPoints(points);
                                  }}
                                >
                                  <Marker
                                    position={{
                                      lat: Number(
                                        rowData?.fromGeoLocation?.split(",")[0]
                                      ),
                                      lng: Number(
                                        rowData?.fromGeoLocation?.split(",")[1]
                                      ),
                                    }}
                                    onMouseOver={() => setIsOpen(true)}
                                    onMouseOut={() => setIsOpen(false)}
                                  >
                                    {isOpen && (
                                      <InfoWindow
                                        position={{
                                          lat: Number(
                                            rowData?.fromGeoLocation?.split(
                                              ","
                                            )[0]
                                          ),
                                          lng: Number(
                                            rowData?.fromGeoLocation?.split(
                                              ","
                                            )[1]
                                          ),
                                        }}
                                      >
                                        <div>{rowData?.transportVehicleNo}</div>
                                      </InfoWindow>
                                    )}
                                  </Marker>
                                  <Marker
                                    position={{
                                      lat: Number(
                                        rowData?.toGeoLocation?.split(",")[0]
                                      ),
                                      lng: Number(
                                        rowData?.toGeoLocation?.split(",")[1]
                                      ),
                                    }}
                                  />
                                  <Polyline
                                    path={[
                                      {
                                        lat: Number(
                                          rowData?.fromGeoLocation?.split(
                                            ","
                                          )[0]
                                        ),
                                        lng: Number(
                                          rowData?.fromGeoLocation?.split(
                                            ","
                                          )[1]
                                        ),
                                      },
                                      {
                                        lat: Number(
                                          rowData?.toGeoLocation?.split(",")[0]
                                        ),
                                        lng: Number(
                                          rowData?.toGeoLocation?.split(",")[1]
                                        ),
                                      },
                                    ]}
                                    options={{
                                      strokeColor: "#171b16ff",
                                      strokeOpacity: 0.4,
                                      strokeWeight: 4,
                                    }}
                                  />
                                  {arrowPoints?.map((point, i) => {
                                    const position = {
                                      lat: point.lat(),
                                      lng: point.lng(),
                                    };
                                    return (
                                      <Marker
                                        key={i}
                                        position={position}
                                        icon={{
                                          path: window?.google?.maps?.SymbolPath
                                            ?.CIRCLE,
                                          scale: 4,
                                          fillColor: "#29c21bff",
                                          fillOpacity: 1,
                                          strokeWeight: 0,
                                        }}
                                        onMouseOver={async () => {
                                          const name = await getLocationName(
                                            position.lat,
                                            position.lng
                                          );
                                          setActiveMarker(i);
                                          setActiveMarkerInfo({
                                            name,
                                            lat: position.lat,
                                            lng: position.lng,
                                          });
                                        }}
                                        onMouseOut={() => {
                                          setActiveMarker(null);
                                          setActiveMarkerInfo(null);
                                        }}
                                        onClick={async () => {
                                          const name = await getLocationName(
                                            position.lat,
                                            position.lng
                                          );
                                          setActiveMarker(i);
                                          setActiveMarkerInfo({
                                            name,
                                            lat: position.lat,
                                            lng: position.lng,
                                          });
                                        }}
                                      >
                                        {activeMarker === i &&
                                          activeMarkerInfo && (
                                            <InfoWindow
                                              position={position}
                                              onCloseClick={() => {
                                                setActiveMarker(null);
                                                setActiveMarkerInfo(null);
                                              }}
                                            >
                                              <div style={{ fontSize: "12px" }}>
                                                <br />
                                                Location Name:&nbsp;
                                                <strong>
                                                  {activeMarkerInfo.name}
                                                </strong>
                                                <br />
                                                Lat:&nbsp;
                                                <strong>
                                                  {position.lat.toFixed(5)}
                                                </strong>
                                                <br />
                                                Lng:&nbsp;
                                                <strong>
                                                  {position.lng.toFixed(5)}
                                                </strong>
                                              </div>
                                            </InfoWindow>
                                          )}
                                      </Marker>
                                    );
                                  })}
                                </GoogleMap>
                              </LoadScript>
                              {/* </>
                                        ) : (
                                          <>
                                            <h6>Loading map...</h6>
                                          </>
                                        )} */}
                            </>
                          ) : (
                            <>
                              <h6>No Data Found!!</h6>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </Item>
            <Item title="View Dispatch Trip Details" icon="detailslayout">
              <>
                <div className="row content-header">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="row">
                      <div className="col-12 col-lg-12">
                        <div className="form-group mb-2">
                          <DataGrid
                            dataSource={dispatchTripDetails}
                            showColumnLines={false}
                            showRowLines={true}
                            showBorders={true}
                            allowColumnResizing={false}
                            allowColumnReordering={true}
                            columnAutoWidth={true}
                          >
                            <Column
                              dataField="transportVehicleNo"
                              caption="Vehicle No"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                            />
                            <Column
                              dataField="currentDispatchLocation"
                              caption="Current Location"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                              width={150}
                            />
                            <Column
                              dataField="fromDispatchLocation"
                              caption="From Location"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                              width={150}
                            />
                            <Column
                              dataField="toDispatchLocation"
                              caption="To Location"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                              width={150}
                            />
                            <Column
                              dataField="lastKms"
                              caption="Last Kms Travelled"
                              alignment={"center"}
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                            />
                            <Column
                              dataField="totalKms"
                              caption="Total Kms"
                              alignment={"center"}
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                            />
                            <Column
                              dataField="entryDate"
                              caption="Entry Time"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                              dataType="datetime"
                              format={DefaultDateFormat.GridDateTime24Format}
                            />
                            <Column
                              dataField="travelDuration"
                              caption="Travel Duration"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                            />
                            <Column
                              dataField="etaDate"
                              caption="ETA"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                              dataType="datetime"
                              format={DefaultDateFormat.GridDateTime24Format}
                            />
                            <Column
                              dataField="dispatchByUserName"
                              caption="Dispatch By"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                            />
                            <Column
                              dataField="dispatchDetailsDate"
                              caption="Dispatch Date"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                              dataType="datetime"
                              format={DefaultDateFormat.GridDateTime24Format}
                            />
                            <HeaderFilter visible={false} />
                            <SearchPanel
                              visible={true}
                              highlightCaseSensitive={true}
                              width={240}
                              placeholder="Search..."
                            />
                          </DataGrid>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    title="Cancel"
                    onClick={() => {
                      setIsOpen(false);
                      setRowData(null);
                    }}
                  >
                    <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
                  </button>
                </div>
              </>
            </Item>
          </TabPanel>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
